<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  /** Whether to display success status */
  success?: boolean
  /** Whether to display danger status */
  danger?: boolean
}

const { danger, success } = defineProps<Props>()

defineOptions({
  name: 'BaseAlert'
})

const status = computed(() => {
  if (danger) {
    return 'danger'
  }
  if (success) {
    return 'success'
  }
  return 'primary'
})

const statusIcon = computed(
  () =>
    ({
      danger: '$alert-outline',
      success: '$check',
      primary: '$information-outline'
    })[status.value]
)
</script>

<template>
  <div
    class="flex items-start gap-x-2 rounded-sm border-y-2 border-r-2 border-l-8 p-2 md:p-4"
    :class="`border-${status} bg-${status}-light`"
  >
    <div class="flex fill-current">
      <VIcon
        :icon="statusIcon"
        :aria-label="status"
        size="1.25rem"
        :class="`text-${status}`"
      />
    </div>
    <div class="text-sm">
      <slot></slot>
    </div>
  </div>
</template>
